import type { ReactNode } from 'react';

/**
 * Shared empty-state for lists/tables so "no data" looks consistent across the
 * app instead of bare table rows or ad-hoc markup (MYSKUX-019). Uses the
 * existing .empty-state styles. The icon should be a Lucide component — never
 * an emoji string (DESIGN.md product integrity rules).
 */
export function EmptyState({ icon, title, description, action }: {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state-icon" aria-hidden="true">{icon}</div>}
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}
